import React from "react"
import cn from "classnames"
import Icon from "../general/Icon";
import { t } from "../../i18n"

export interface ButtonItem<T = string> {
  id: T;
  i18nKey: string;
  icon?: SvgSymbolId;
}

type OnChange<T> = (id: T) => void;

interface ButtonSwitchProps<T> {
  activeId: T;
  buttons: ButtonItem<T>[];
  className?: string;
  onChange: OnChange<T>;
}

const ButtonSwitch = <T,>(props: ButtonSwitchProps<T>): JSX.Element => {
  const { activeId, buttons, className, onChange } = props

  return (
    <div className={cn("ButtonSwitch", className)}>
      {buttons.map((item: ButtonItem<T>) => (
        <button
          className={cn("ButtonSwitch-button", { isActive: item.id === activeId })}
          id={`btn_${String(item.id)}`}
          key={String(item.id)}
          onClick={() => onChange(item.id)}
          type="button"
        >
          {t(item.i18nKey)}
          {item.icon && (
            <Icon className="border border-porcelain rounded-2xl ml-2" size="16" symbolId={item.icon} />
          )}
        </button>
      ))}
    </div>
  )
}

export default ButtonSwitch
